import { LabelHTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    text?: string
}

export function Label({ text, ...rest }: LabelProps) {
    return (
        <div>
            <label
                {...rest} className={twMerge("tw-justify-start tw-items-start tw-text-black tw-font-semibold", rest.className)}>
                {text}
            </label>
        </div>
    )
}
